/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  faEdit,
  faFloppyDisk,
  faMapMarkerAlt,
  faSpinner,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, CardHeader, Col, Form, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, CardBody, Label } from "reactstrap";
import Swal from "sweetalert2";
import BreadCrumbs from "../../../../components/BreadCrumbs";
import ButtonComponent from "../../../../components/ButtonComponent";
import ControlledRowTextField from "../../../../components/ControlledRowTextField";
import ControlledRowTextFieldAddress from "../../../../components/ControlledRowTextFieldAddress";
import ControlledRowTextFieldTime from "../../../../components/ControlledRowTextFieldTime";
import ControlledSelect from "../../../../components/ControlledSelect";
import ControlledRowTextFieldDropDown from "../../../../components/ControlledTextFieldDropDown";
import EditPhotoUpload from "../../../../components/EditPhotoUpload";
import { uploadImage } from "../../../../components/imageUploadCompont";
import LoadingMessage from "../../../../components/LoadingMessage";
import Map from "../../../../components/LocationSelectorModal";
import { Restaurant } from "../../../../components/ReastaurantSlectModal";
import { RESTAURANT_EDIT_FORM_NAME } from "../../../../constants/constans";
import { getImageUrl } from "../../../../dummyData/FoodAttributes";
import {
  useDeleteRestaurantHttpsMutation,
  useGetRestaurantCategoriesQuery,
  useGetRestaurantFlowTypesQuery,
  useGetRestaurantPropertiesQuery,
  useLazyGetRestaurantDetailsByIdQuery,
  useUpdateRestaurantHttpsMutation,
  useUpdateRestaurantImageMutation,
  useUploadRestaurantLogoFileExtntionHttpsMutation,
} from "../../../../redux/services/restaurantServices";
import {
  capitalizeFirstLetter,
  capitalizeFirstLetterEdit,
  categoryTagsOptionsFunctionEdit,
  formatTime,
} from "../../../../utility/Utility";
import './index.css';

type Location = {
  latitude: any;
  longitude: any;
};

export type RestaurantFormData = {
  address: string;
  displayName: string;
  categoryTags: any;
  imageUrl: string;
  location: Location;
  ownerId: string;
  hasOffers: boolean;
  openingTime: any;
  closingTime: any;
  type: any;
  imageReference: any;
  latitude: any;
  longitude: any;
  restaurantProperties?: any;
  supportsDirectOrders?: boolean;
  canCollectMoney?: boolean;
  flowTypes?: any;
  acceptCartReturns?: boolean;
  deliverySettings: {
    isFreeDelivery: boolean;
    perItemDeliveryFee: number;
  };
};

const EditReasturant = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const restaurant: Restaurant = location.state?.restaurant || {};

  const restaurantDetails = useSelector(
    (state: any) => state.selectedRestaurantDetails
  );
  const [
    triggerRestaurantDetailsById,
    { data: restaurantData, isLoading: isLoadingDetails },
  ] = useLazyGetRestaurantDetailsByIdQuery();

  useEffect(() => {
    if (restaurant.id) {
      triggerRestaurantDetailsById(restaurant.id);
    }
  }, [restaurant.id, triggerRestaurantDetailsById]);

  const [isFreeDelivery, setIsFreeDelivery] = useState(false);
  const [imageDimensions, setImageDimensions] = useState<{
    width: number;
    height: number;
  } | null>(null);

  const { control, handleSubmit, setError, setValue, watch } =
    useForm<RestaurantFormData>({
      defaultValues: {
        ownerId: "",
        address: "",
        displayName: "",
        imageUrl: "",
        location: {
          latitude: 0,
          longitude: 0,
        },
        categoryTags: [],
        restaurantProperties: [],
        openingTime: "",
        closingTime: "",
        type: "",
        latitude: 0,
        longitude: 0,
        supportsDirectOrders: false,
        canCollectMoney: false,
        flowTypes: [],
        acceptCartReturns: false,
        deliverySettings: {
          isFreeDelivery: false,
          perItemDeliveryFee: 0,
        },
      },
    });

  // NEW: Update form values when API data is fetched
  useEffect(() => {
    if (restaurantData?.restaurant) {
      const data = restaurantData.restaurant;

      // Basic fields
      setValue("address", data.address || "");
      setValue("displayName", data.displayName || "");
      setValue("imageUrl", data.imageUrl || "");
      setValue("latitude", data.location?.latitude || 0);
      setValue("longitude", data.location?.longitude || 0);
      setValue("openingTime", data.openingTime || "");
      setValue("closingTime", data.closingTime || "");
      setValue("type", data.type || "");
      setValue("supportsDirectOrders", data.supportsDirectOrders || false);
      setValue("canCollectMoney", data.canCollectMoney || false);
      setValue("acceptCartReturns", data.acceptCartReturns || false);

      // Delivery settings - CRITICAL FIX
      setValue(
        "deliverySettings.isFreeDelivery",
        data.deliverySettings?.isFreeDelivery || false
      );
      setValue(
        "deliverySettings.perItemDeliveryFee",
        data.deliverySettings?.perItemDeliveryFee || 0
      );
      setIsFreeDelivery(data.deliverySettings?.isFreeDelivery || false);

      // Category tags
      if (data.categoryTags && Array.isArray(data.categoryTags)) {
        setValue(
          "categoryTags",
          data.categoryTags.map((tag: string) => ({
            label: capitalizeFirstLetterEdit(tag),
            value: capitalizeFirstLetterEdit(tag),
          }))
        );
      }

      // Restaurant properties
      if (
        data.restaurantProperties &&
        Array.isArray(data.restaurantProperties)
      ) {
        setValue(
          "restaurantProperties",
          data.restaurantProperties.map((tag: string) => ({
            label: (
              <div
                style={{ display: "flex", justifyContent: "left", gap: "2%" }}
              >
                <img
                  src={getImageUrl(tag)}
                  alt={tag}
                  width="20px"
                  height="20px"
                />
                {tag}
              </div>
            ),
            value: capitalizeFirstLetterEdit(tag),
          }))
        );
      }

      // Flow types
      if (data.flowTypes && Array.isArray(data.flowTypes)) {
        setValue(
          "flowTypes",
          data.flowTypes.map((tag: string) => ({
            label: tag,
            value: tag,
          }))
        );
      }

      // Update location state
      if (data.location) {
        setSelectedLocation({
          lat: data.location.latitude,
          lng: data.location.longitude,
        });
      }
    }
  }, [restaurantData, setValue]);

  const [selectedLocation, setSelectedLocation] = useState({
    lat: 28.7041,
    lng: 77.1025,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
  const [showImageUpdateModal, setShowImageUpdateModal] = useState(false);
  const [isImageUpdateLoading, setIsImageUpdateLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [updateRestaurant] = useUpdateRestaurantHttpsMutation();

  const restaurantId = localStorage.getItem("editableRestaurantId") || "";

  const updateRestaurantMutation = async (
    requestData: RestaurantFormData,
    restaurantId: any
  ) => {
    try {
      setIsLoading(true);
      const restaurantUpdateResponse: any = await updateRestaurant({
        restaurantId: restaurantId,
        data: requestData,
      });
      if ("data" in restaurantUpdateResponse) {
        toast.success("Restaurant Updated");
        navigate("/profile");
      } else if (restaurantUpdateResponse?.error?.originalStatus === 409) {
        toast.error(
          "You cannot create two restaurants from same name in same place"
        );
      } else if (
        restaurantUpdateResponse?.error?.originalStatus === 400 &&
        restaurantUpdateResponse?.error?.data ===
          "Some removed category tags are still used by menu items"
      ) {
        toast.error(
          "Some removed category tags are still used by menu items. Please remove them from the menu items before updating the restaurant."
        );
      }
    } catch (error: any) {
      console.error("Error updating restaurant:", error);
      if (error.originalStatus === 409) {
        toast.error(
          "You cannot create two restaurants from same name in same place"
        );
      }
      if (
        error.originalStatus === 400 &&
        error.data === "Some removed category tags are still used by menu items"
      ) {
        toast.error(
          "Some removed category tags are still used by menu items. Please remove them from the menu items before updating the restaurant."
        );
      }
      toast.error("Failed to update restaurant. please check Enter Values");
    } finally {
      setIsLoading(false);
    }
  };

  //Location

  const handleLocationModalClose = () => {
    setShowModal(false);
  };

  const handleLocationSave = (
    latitude: number,
    longitude: number,
    address: string
  ) => {
    setSelectedLocation({ lat: latitude, lng: longitude });
    setValue("latitude", latitude);
    setValue("longitude", longitude);
    setValue("address", address);
  };

  //Location

  //Category Tags
  const { data, error, isSuccess } = useGetRestaurantCategoriesQuery("");

  let categoryTagsOptions = [{ value: "", label: "" }];

  if (isSuccess) {
    categoryTagsOptions = categoryTagsOptionsFunctionEdit(data) || [
      { value: "", label: "" },
    ];
  }

  // Filter out existing category tags from the options
  const existingCategoryTags = (restaurant.categoryTags || []).map(
    (tag: string) => capitalizeFirstLetterEdit(tag)
  );

  const filteredCategoryTagsOptions = categoryTagsOptions.filter(
    (option) => !existingCategoryTags.includes(option.value)
  );
  //Category Tags

  //restaurantProperties
  const restaurantPropertiesFunction = (data: any) => {
    if (data && data.RestaurantPropertiesList) {
      const restauarntPropertiesArray = data.RestaurantPropertiesList;
      return restauarntPropertiesArray.map((item: any) => {
        return {
          value: capitalizeFirstLetter(item.displayName),
          label: (
            <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
              <img
                src={getImageUrl(item.displayName)}
                alt={item.displayName}
                width="20px"
                height="20px"
              />
              {item.displayName}
            </div>
          ),
        };
      });
    } else {
      console.error("Invalid data structure:", data);
      return [];
    }
  };

  const {
    data: restaurantProperties,
    error: errorRestaurantProperties,
    isSuccess: isGetRestaurantPropertiesSuccess,
  } = useGetRestaurantPropertiesQuery("");

  let restaurantPropertiesOptions = [{ value: "", label: "" }];
  if (isGetRestaurantPropertiesSuccess) {
    restaurantPropertiesOptions = restaurantPropertiesFunction(
      restaurantProperties
    ) || [{ value: "", label: "" }];
  }

  // restaurant Flow Types
  const restaurantFlowTypesFunction = (data: any) => {
    if (data && data.FlowTypesList) {
      const restaurantFlowTypessArray = data.FlowTypesList;
      return restaurantFlowTypessArray.map((item: any) => {
        return {
          value: item.displayName,
          label: (
            <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
              {item.displayName}
            </div>
          ),
        };
      });
    } else {
      console.error("Invalid data structure:", data);
      return [];
    }
  };

  const {
    data: restaurantFlowTypes,
    error: errorRestaurantFlowTypes,
    isSuccess: isGetRestaurantFlowTypesSuccess,
  } = useGetRestaurantFlowTypesQuery("");
  let restaurantFlowTypesOptions = [{ value: "", label: "" }];
  if (isGetRestaurantFlowTypesSuccess) {
    restaurantFlowTypesOptions = restaurantFlowTypesFunction(
      restaurantFlowTypes
    ) || [{ value: "", label: "" }];
  }

  // Filter out existing category tags from the options
  const existingrestaurantProperties = (
    restaurant?.restaurantProperties || []
  ).map((tag: string) => capitalizeFirstLetterEdit(tag));

  const filteredrestaurantProperties = restaurantPropertiesOptions?.filter(
    (option) => !existingrestaurantProperties.includes(option.value)
  );

  // Add this for flow types (similar to restaurant properties)
  const existingFlowTypes = (restaurant?.flowTypes || []).map((tag: string) =>
    capitalizeFirstLetterEdit(tag)
  );

  const filteredFlowTypesOptions = restaurantFlowTypesOptions?.filter(
    (option) => !existingFlowTypes.includes(option.value)
  );

  //Category Tags

  const onSubmit = async (data: RestaurantFormData) => {
    const latitude = parseFloat(data.latitude);
    const longitude = parseFloat(data.longitude);
    const categroryTagList = data?.categoryTags.map((item: any) => item.value);
    const restaurantProperties = data?.restaurantProperties.map(
      (item: any) => item.value
    );
    const flowTypes = data?.flowTypes.map((item: any) => item.value);
    const openingTime = data.openingTime
      ? formatTime(data.openingTime)
      : restaurant.openingTime;
    const closingTime = data.closingTime
      ? formatTime(data.closingTime)
      : restaurant.closingTime;
    const updatedData = {
      ...data,
      openingTime: data.openingTime,
      closingTime: data.closingTime,
      location: {
        latitude: latitude,
        longitude: longitude,
      },
      categoryTags: categroryTagList,
      restaurantProperties: restaurantProperties,
      supportsDirectOrders: data.supportsDirectOrders,
      canCollectMoney: data.canCollectMoney,
      flowTypes: flowTypes,
      deliverySettings: {
        isFreeDelivery: data.deliverySettings.isFreeDelivery,
        perItemDeliveryFee:
          parseFloat(data.deliverySettings.perItemDeliveryFee.toString()) || 0,
      },
    };
    updateRestaurantMutation(updatedData, restaurantId);
  };

  const [deleteRestaurant] = useDeleteRestaurantHttpsMutation();

  const handleDeleteAction = () => {
    const editableRestaurantId =
      localStorage.getItem("editableRestaurantId") || "";

    const selectedRestaurantId =
      localStorage.getItem("selectedRestaurantId") || "";

    if (editableRestaurantId === selectedRestaurantId) {
      toast.warning(
        "You have selected this restaurant, you cannot delete it. If this is your only restaurant just create a another restaurant & delete this."
      );
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoadingDelete(true);
          setIsDeleting(true);
          await deleteRestaurant({
            restaurantId: editableRestaurantId,
            data: [],
          });
          toast.success("Restaurant Deleted");
          navigate("/profile");
        } catch (error) {
          console.error("Failed to delete restaurant:", error);
          toast.error("An error occurred while deleting the restaurant");
        } finally {
          setIsLoading(false);
          setIsLoadingDelete(false);
          setIsDeleting(false);
        }
      }
    });
  };

  //image Update

  const [uploadedImgDetails, setUploadedImgDetails] = useState<{
    imgSrc: string;
    formData: any;
    fileExtention: string;
  }>({
    imgSrc: "",
    formData: "",
    fileExtention: "",
  });

  const imageUploadCallback = (e: any) => {
    setUploadedImgDetails({
      ...uploadedImgDetails,
      imgSrc: e.imgSrc,
      formData: e.formData,
      fileExtention: e.fileExtention,
    });
    setIsSaveButtonDisabled(false);
  };

  const handleUpdatePhoto = () => {
    setShowImageUpdateModal(true);
  };

  const handleCloseModal = () => {
    setShowImageUpdateModal(false);
    setIsSaveButtonDisabled(true);
    setUploadedImgDetails({ imgSrc: "", formData: "", fileExtention: "" });
  };

  const [getRestaurantImageReference] =
    useUploadRestaurantLogoFileExtntionHttpsMutation();
  const [updateRestaurantImage] = useUpdateRestaurantImageMutation();

  const handleCartImageUpdate = async () => {
    setIsImageUpdateLoading(true);
    const imageRef = await uploadImage(getRestaurantImageReference, {
      fileExtention: uploadedImgDetails.fileExtention,
      formData: uploadedImgDetails.formData,
    });
    const updateImageResponse = await updateRestaurantImage({
      imageRef: imageRef,
      restId: restaurant.id,
      oldImgUrl: restaurant.imageUrl,
    });
    if ("data" in updateImageResponse) {
      toast.success("Restaurant Image Successfully Updated");
      navigate("/profile");
    } else {
      toast.error("Something Went Wrong");
    }
    setIsImageUpdateLoading(false);
  };

  const handleEdit = () => {
    setIsEditMode(!isEditMode);
  };

  const handleImageLoad = (event: React.SyntheticEvent<HTMLImageElement>) => {
    const img = event.currentTarget;
    setImageDimensions({
      width: img.naturalWidth,
      height: img.naturalHeight,
    });
  };

  const getAspectRatioClass = () => {
    if (!imageDimensions) return "square";

    const ratio = imageDimensions.width / imageDimensions.height;

    if (ratio > 1.2) return "landscape";
    if (ratio < 0.8) return "portrait";
    return "square";
  };

  return (
    <>
      <Card>
        <CardHeader className="d-flex justify-content-between bg-white">
          <h4>{RESTAURANT_EDIT_FORM_NAME}</h4>
          <Button variant="light" onClick={handleEdit}>
            <FontAwesomeIcon icon={faEdit} title="Edit" color="#699BF7" />
          </Button>
        </CardHeader>
        <CardBody>
          {!isSuccess || isLoadingDetails ? (
            <div className="bg-white">
              <LoadingMessage />
            </div>
          ) : (
            <>
              <Form
                className="auth-login-form mt-4"
                onSubmit={handleSubmit(onSubmit)}
              >
        
<Row>
  <Col lg="4">
    <Label>Restaurant Photo</Label>
  </Col>
  <Col lg="8">
    <div className="restaurant-photo-container">
      <img
        src={
          restaurantData?.restaurant?.imageUrl ||
          restaurant.imageUrl ||
          restaurantDetails.imageUrl
        }
        alt="restaurant"
        className="restaurant-photo-uniform"
        onLoad={handleImageLoad}
      />
      <Button
        variant="danger"
        size="sm"
        onClick={handleUpdatePhoto}
        className="edit-photo-btn"
        title="Edit Photo"
        disabled={!isEditMode}
      >
        <FontAwesomeIcon icon={faEdit} />
      </Button>
    </div>
  </Col>
</Row>
                <hr />
                <ControlledRowTextField
                  label={"Name"}
                  inputName={"displayName"}
                  inputType={"text"}
                  placeholder={"Enter Restaurant Name"}
                  isRequired={true}
                  control={control}
                  isDisabled={!isEditMode}
                />
                <hr />
                <ControlledRowTextFieldAddress
                  label={"Address"}
                  inputName={"address"}
                  inputType={"text"}
                  placeholder={"Enter Restaurant Address"}
                  isRequired={true}
                  control={control}
                  setShowModal={setShowModal}
                />
                <Row style={{ display: "none" }}>
                  <Col lg="5">
                    <ControlledRowTextField
                      label={"Latitude"}
                      inputName={"latitude"}
                      inputType={"number"}
                      placeholder={"Enter Latitude"}
                      isRequired={true}
                      control={control}
                    />
                  </Col>
                  <Col lg="5">
                    <ControlledRowTextField
                      label={"Longitude"}
                      inputName={"longitude"}
                      inputType={"number"}
                      placeholder={"Enter Longitude"}
                      isRequired={true}
                      control={control}
                    />
                  </Col>
                  <Col lg="2">
                    <Button
                      variant="secondary"
                      type="button"
                      onClick={() => setShowModal(true)}
                    >
                      <FontAwesomeIcon icon={faMapMarkerAlt} />
                    </Button>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col>
                    <Label>Restaurant available time</Label>
                  </Col>
                  <Col>
                    <ControlledRowTextFieldTime
                      label={"Opening Time"}
                      inputName={"openingTime"}
                      control={control}
                      isRequired={true}
                      inputType={"time"}
                      isDisabled={!isEditMode}
                    />
                  </Col>
                  <Col>
                    <ControlledRowTextFieldTime
                      label={"Closing Time"}
                      inputName={"closingTime"}
                      inputType={"time"}
                      control={control}
                      isRequired={true}
                      isDisabled={!isEditMode}
                    />
                  </Col>
                </Row>
                <hr />
                <ControlledSelect
                  label={"Categories"}
                  inputName={"categoryTags"}
                  control={control}
                  isMulti={true}
                  optionsList={categoryTagsOptions}
                  isDisabled={!isEditMode}
                />
                <hr />
                <ControlledSelect
                  label={"Restaurant Properties"}
                  inputName={"restaurantProperties"}
                  control={control}
                  isMulti={true}
                  optionsList={restaurantPropertiesOptions}
                  isDisabled={!isEditMode}
                />
                <hr />
                <ControlledSelect
                  label={"Flow Types"}
                  inputName={"flowTypes"}
                  control={control}
                  isMulti={true}
                  optionsList={restaurantFlowTypesOptions}
                  isDisabled={!isEditMode}
                />
                <hr />
                <ControlledRowTextFieldDropDown
                  label={"Type"}
                  inputName={"type"}
                  inputType={"dropdown"}
                  placeholder={"Select Restaurant Type"}
                  isRequired={true}
                  control={control}
                  defaultValue={restaurant.type || restaurantDetails.type}
                  isDisabled={!isEditMode}
                />
                <hr />
                <Row>
                  <Col lg="4">
                    <Label
                      className="form-check-label"
                      htmlFor="supportsDirectOrders"
                    >
                      Can Direct Pickup
                    </Label>
                  </Col>
                  <Col lg="8">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="supportsDirectOrders"
                      checked={watch("supportsDirectOrders")}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setValue("supportsDirectOrders", event.target.checked);
                      }}
                      disabled={!isEditMode}
                    />
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col lg="4">
                    <Label
                      className="form-check-label"
                      htmlFor="canCollectMoney"
                    >
                      Collect Money
                    </Label>
                  </Col>
                  <Col lg="8">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="canCollectMoney"
                      checked={watch("canCollectMoney")}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setValue("canCollectMoney", event.target.checked);
                      }}
                      disabled={!isEditMode}
                    />
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col lg="4">
                    <Label
                      className="form-check-label"
                      htmlFor="acceptCartReturns"
                    >
                      Accept Cart Return Requests
                    </Label>
                  </Col>
                  <Col lg="8">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="acceptCartReturns"
                      checked={watch("acceptCartReturns")}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setValue("acceptCartReturns", event.target.checked);
                      }}
                      disabled={!isEditMode}
                    />
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col lg="4">
                    <Label
                      className="form-check-label"
                      htmlFor="isFreeDelivery"
                    >
                      Free Delivery
                    </Label>
                  </Col>
                  <Col lg="8">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="isFreeDelivery"
                      checked={watch("deliverySettings.isFreeDelivery")}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setIsFreeDelivery(event.target.checked);
                        setValue(
                          "deliverySettings.isFreeDelivery",
                          event.target.checked
                        );
                      }}
                      disabled={!isEditMode}
                    />
                  </Col>
                </Row>
                <hr />

                <ControlledRowTextField
                  label={"Per Item Delivery Fee"}
                  inputName={"deliverySettings.perItemDeliveryFee"}
                  inputType={"number"}
                  placeholder={"Enter delivery fee"}
                  control={control}
                  rules={{
                    required: "Delivery fee is required",
                    min: {
                      value: 0,
                      message: "Delivery fee cannot be negative",
                    },
                  }}
                  isDisabled={!isEditMode}
                />
                <br />
                <Modal
                  show={showModal}
                  onHide={() => setShowModal(false)}
                  centered
                  size="lg"
                  backdrop="static"
                  keyboard={false}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Select Your Location</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Map onSaveLocation={handleLocationSave} />
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => handleLocationModalClose()}
                    >
                      Save
                    </Button>
                  </Modal.Footer>
                </Modal>
                <br />
                <div style={{ textAlign: "end" }}>
                  {isLoading ? (
                    <ButtonComponent
                      type="submit"
                      icon={
                        <FontAwesomeIcon
                          icon={faSpinner}
                          spin
                          title="Saving..."
                        />
                      }
                      titel="Saving..."
                      isDisabled={true}
                    />
                  ) : (
                    <ButtonComponent
                      type="submit"
                      icon={<FontAwesomeIcon icon={faFloppyDisk} size={"sm"} />}
                      titel="Save"
                      isDisabled={isLoading || isDeleting || !isEditMode}
                    />
                  )}
                  {isLoadingDelete ? (
                    <Button type="button" disabled={true} variant="danger">
                      <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                      Deleting...
                    </Button>
                  ) : (
                    <Button
                      variant="danger"
                      disabled={isLoading || isDeleting}
                      type="button"
                      onClick={handleDeleteAction}
                    >
                      <FontAwesomeIcon icon={faTrash} className="me-2" />
                      Delete
                    </Button>
                  )}
                </div>
              </Form>
              <Modal
                show={showImageUpdateModal}
                onHide={handleCloseModal}
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>Update Profile Photo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <EditPhotoUpload
                    imageUrl={uploadedImgDetails.imgSrc}
                    onUpload={imageUploadCallback}
                  />
                </Modal.Body>
                <Modal.Footer>
                  {isImageUpdateLoading ? (
                    <>
                      <ButtonComponent
                        titel="Saving..."
                        icon={<FontAwesomeIcon icon={faSpinner} spin />}
                        isDisabled={
                          isSaveButtonDisabled || isImageUpdateLoading
                        }
                        onClick={handleCartImageUpdate}
                      />
                    </>
                  ) : (
                    <ButtonComponent
                      titel="Save"
                      isDisabled={isSaveButtonDisabled || isImageUpdateLoading}
                      onClick={handleCartImageUpdate}
                    />
                  )}
                </Modal.Footer>
              </Modal>
            </>
          )}
        </CardBody>
      </Card>
    </>
  );
};

export default EditReasturant;
